<app-header></app-header>
<main class="pages">
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <!-- <nav aria-label="breadcrumb text-center">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="">Home</a></li>
                            <li class="breadcrumb-item active" aria-current="page">It and Banking</li>
                        </ol>
                    </nav> -->
                    <h1 alt="ITES survey solution" class="h1-title">Require an effective feedback solution for your IT services?</h1>
                    <p class="sub-text mt-3">CViewSurvey collects relevant data from different directions, to gauge customer's expectations. These surveys provide an opportunity to reflect the efficiency of your product or services in the current market.</p>
                    <div class="mt-lg-5 mt-0">
                        <a title="" class="btn btn-lg btn-success px-4 text-uppercase  mr-lg-2" data-toggle="modal" data-target="#callBack" id="callback"> Request a
                            Demo</a>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid" alt="IT Survey" title="" src="assets/it&ites.svg">

                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="mb-lg-5 pb-lg-5">
        <div class="container">
            <div class="col-md-12">
                <div class="featured video card border-0 shadow mt-lg-5">
                    <div class="card-body">
                        <h2 alt="survey for IT field" class="text-center h2-title mb-4">IT & ITES</h2>
                        <p class="text-center sub-text">With the help of our solutions, you can identify the strengths and weaknesses of your employees, processes, service, and policies. You can completely transform your IT operations by delving into our survey solutions app, right
                            away and get actionable insights with powerful reports and graphs.</p>
                    </div>
                </div>
                <!-- play-video -->
                <div class="play-video">
                    <a class="video-play-button" (click)="scroll(target)">
                        <span></span>
                    </a>
                </div>
            </div>
        </div>
    </section>

    <section class="mt-5 mb-lg-5 pt-5 pb-lg-5">
        <div class="container mb-lg-5 ">
            <h3 alt="effective feedback solution" class="text-center">CView IT surveys can assist you in the following ways:</h3>
        </div>

        <div class="features-screenshot-right">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid px-lg-5 mb-lg-0 mb-3" alt="IT and ITES Survey" src="assets/insights.svg">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <h3 alt="effective feedback solution" class="feature-heading">PROVIDE INSIGHTFUL DATA</h3>
                        <p class="sub-text text-justify">You can get insight of your employees and customers through CViewSurvey, this also allows you to screen prospective opportunities and hidden obstacles. Our survey helps you in understanding the efficiency of your operations, functioning
                            of the organisation and satisfaction of your customers.</p>

                        <h5 class="feature-heading mt-4">ENSURE SAFETY AND SECURITY</h5>
                        <p class="sub-text text-justify">Worry not! Your data is in safe hands.As the IT sector needs complete security, we understand the urge of confidentiality along with accuracy. We are happy to help you in maintaining top security with our cloud-based data storage,
                            guaranteeing total reliability of your data. </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="features-screenshot-left">
            <div class="container">
                <div class="row align-items-center mob-column-reverse">
                    <div class="col-md-6">
                        <h3 alt="effective feedback solution" class="feature-heading">ACTS AS A FUTURE GROWTH PLATFORM</h3>
                        <p class="sub-text text-justify">Analyzing the data gathered, and working accordingly can create a great platform to make future decisions that increase your revenue. Having a refined survey experience can help get the desired growth.</p>
                        <h5 class="feature-heading mt-4">FEEDBACK F0R 360<sup>&deg;</sup> EVALUATION</h5>
                        <p class="sub-text text-justify">Whenever you conduct a survey, it gives you data regarding what your customers think about your products and services, this process generates transparency and helps build a strong and everlasting bond with the customers and engagement
                            with employees.</p>

                    </div>
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid px-lg-5 mb-lg-0 mb-3" alt="Product Satisfaction Survey" src="assets/feedback.svg">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="features-screenshot-right ">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid px-lg-5 mb-lg-0 mb-3" alt="client Satisfaction Survey" src="assets/competitors.svg">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <h3 alt="effective feedback solution" class="feature-heading">BUILDS A STRONG BRAND IMAGE</h3>
                        <p class="sub-text text-justify">Conducting surveys makes your employees and customers feel heard. They feel more connected with the company and in turn might lead the company towards better growth and development.</p>
                        <h5 class="feature-heading mt-4">STAND OUT FROM THE COMPETITION</h5>
                        <p class="sub-text text-justify">In this highly competitive environment, one needs to have an upper edge over their competitors in order to win customers and retain them. Reach out to the right audience and get results in real time.</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="container my-5">
            <p class="text-center sub-text">CViewSurvey provides you with an extensive range of pre-made templates and customized surveys; we assure you the best outcome through real-time data collection and powerful analytics.</p>
        </div> -->
    </section>

    <!-- video-section -->
    <section #target class="bg-primary py-lg-5 mt-lg-5 position-relative">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="solution-video">
                        <iframe width="580" height="335" [src]="safeURL" frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
<app-footer></app-footer>